import { useCallback } from 'react';
import useAction from 'hooks/useAction';
import BaseLoadMore from 'components/molecules/BaseLoadMore/BaseLoadMore';
import { fetchGlobalItems } from 'store/globalSearch/actions';

const LoadMoreGlobalItems = ({ children, group, fetchParams }) => {
  const { isFetching, tagsLeft } = group;

  const fetchGlobal = useAction(fetchGlobalItems);

  const fetchMore = useCallback(() => {
    fetchGlobal(fetchParams);
  }, [fetchGlobal, fetchParams]);

  return (
    <BaseLoadMore
      fetchMore={fetchMore}
      isFetching={isFetching}
      left={tagsLeft}
      fullWidth
      buttonProps={{ size: 'small' }}
    >
      {children}
    </BaseLoadMore>
  );
};

export default LoadMoreGlobalItems;
